import type { FilterApplyFnGetter, FilterModifierRenderFn } from "./typings"

export interface FilterModifierConfig<TValue, TFilterValue, TSerializedModifierFilterValue = TFilterValue> {
	id: string
	getApplyFn: FilterApplyFnGetter<TValue, TFilterValue>
	render: FilterModifierRenderFn<TFilterValue>
	serialize: (filterValue: TFilterValue) => TSerializedModifierFilterValue
	deserialize: (serializedFilterValue: TSerializedModifierFilterValue) => TFilterValue | undefined
}

export class FilterModifier<TValue, TFilterValue, TSerializedModifierFilterValue = TFilterValue> {
	readonly id: string
	readonly getApplyFn: FilterApplyFnGetter<TValue, TFilterValue>
	readonly render: FilterModifierRenderFn<TFilterValue>
	readonly serialize: (filterValue: TFilterValue) => TSerializedModifierFilterValue
	readonly deserialize: (serializedFilterValue: TSerializedModifierFilterValue) => TFilterValue | undefined

	private constructor(config: FilterModifierConfig<TValue, TFilterValue, TSerializedModifierFilterValue>) {
		const { id, getApplyFn, render, serialize, deserialize } = config

		this.id = id
		this.getApplyFn = getApplyFn
		this.render = render
		this.serialize = serialize
		this.deserialize = deserialize
	}

	static create<TValue, TFilterValue, TSerializedModifierFilterValue = TFilterValue>(
		config: FilterModifierConfig<TValue, TFilterValue, TSerializedModifierFilterValue>,
	): FilterModifier<TValue, TFilterValue, TSerializedModifierFilterValue> {
		return new FilterModifier(config)
	}
}
